import React from "react";
import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import { usePermissions } from "../components/PermissionGate";

const ProtectedRoute = ({ component: Component, roles, scopes, children }) => {
  const currentUser = useSelector((state) => state.user);
  const hasPermission = usePermissions({ scopes: scopes });
  const { isOnline, isAppOffline } = useSelector((state) => state.networkStatus);

  if (!currentUser.isLogged) {
    // not logged in so redirect to login page
    return <Navigate to="/login" replace />;
  }

  if (scopes && !hasPermission) {
    if (currentUser.isLogged && (isAppOffline || !isOnline)) {
      return <Navigate to="/order" replace />;
    }
    return <Navigate to="/" replace />;
  }

  // check if route is restricted by role
  if (roles && roles.indexOf(currentUser.role) === -1) {
    // role not authorised so redirect to home page
    if (isAppOffline || !isOnline) {
      return <Navigate to="/order" replace />;
    }
    return <Navigate to="/" replace />;
  }

  // authorised so return component
  if (Component) {
    return <Component />;
  }

  return children ? children : null;
};
export default ProtectedRoute;
